module.exports = __webpack_public_path__ + "img/ic30Alarm.cebcd78f.svg";